import { FadeUp, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Pick Your Minutes",
    copy: "Tap 10, 20, 30, 40 or 50. That's the only decision you make — the engine handles everything else.",
  },
  {
    n: "02",
    title: "Get Your Session Blueprint",
    copy: "Fit50 builds your warm-up, work blocks, rest windows and cooldown to fit your chosen duration — down to the second.",
  },
  {
    n: "03",
    title: "Press Play, Follow Along",
    copy: "Guided video with voice cues, live timers and automatic rest tracking. No planning, no clock-watching, no thinking.",
  },
  {
    n: "04",
    title: "Stack The Minutes",
    copy: "Weekly totals, streaks and intensity minutes turn every session into momentum. Consistency becomes a game you win daily.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="relative py-32 bg-carbon scroll-mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeUp>
        <Eyebrow>How It Works</Eyebrow>
        <h2 className="font-display font-extrabold uppercase tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-2xl">
          Pick your minutes. <span className="text-volt">Press play.</span> Done.
        </h2>
      </FadeUp>

      <div className="mt-16 relative">
        <div className="absolute left-[27px] sm:left-[39px] top-0 bottom-0 w-px bg-white/10" />
        <div className="space-y-12">
          {STEPS.map((s, i) => (
            <FadeUp key={s.n} delay={i * 0.08}>
              <div data-testid={`how-it-works-step-${s.n}`} className="relative grid sm:grid-cols-[80px_1fr] gap-6 items-start group">
                <div className="relative z-10 grid place-items-center h-14 w-14 sm:h-20 sm:w-20 border border-volt/40 bg-obsidian font-display font-black text-xl sm:text-2xl text-volt group-hover:bg-volt group-hover:text-white transition-colors duration-300">
                  {s.n}
                </div>
                <div className="border border-white/10 bg-carbon p-6 sm:p-8 group-hover:border-volt/30 transition-colors duration-300">
                  <h3 className="font-display font-extrabold uppercase text-xl sm:text-2xl leading-tight">{s.title}</h3>
                  <p className="mt-3 text-base text-neutral-400 leading-relaxed max-w-2xl">{s.copy}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  </section>
);
